import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=5a013ffa&scoped=true"
import script from "./AssetDetails.vue?vue&type=script&lang=js"
export * from "./AssetDetails.vue?vue&type=script&lang=js"
import style0 from "./AssetDetails.vue?vue&type=style&index=0&id=5a013ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a013ffa",
  null
  
)

export default component.exports